// action type strings
import * as actionTypes from '../../actionTypes';

export function updateCompany({company, group}) {
  return {
    type: actionTypes.UPDATE_COMPANY,
    company,
    newGroup: group
  };
}

export function updateCompanyContacts(companyContacts) {
  return {
    type: actionTypes.UPDATE_COMPANY_CONTACTS,
    companyContacts,
  };
}

export function updateCompanyJobs({companyJobs}) {
  return {
    type: actionTypes.UPDATE_COMPANY_JOBS,
    companyJobs,
  };
}

export function filterCompanyJobs(filters) {
  return {
    type: actionTypes.FILTER_COMPANY_JOBS,
    filters,
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/companies.js